exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".player_div{display:inline-block;text-align:center;overflow:hidden;position:relative}.player_div:hover{display:block}.video-js .vjs-icon-placeholder{width:100%;height:100%;display:block}.video-js .vjs-big-play-button{height:70px!important;width:70px!important;line-height:70px!important;text-align:center;background:rgba(0,0,0,.5)!important;border-radius:50px!important;top:50%!important;left:50%!important;margin-left:-35px!important;margin-top:-35px!important}", ""]);

// exports
